import axiosClient from 'utils/axiosClient';
import api from 'api';
import {formData} from 'utils/helpers/formData';

const getVacancies = async (params?: any) => {
	const response = await axiosClient.get(api.CAREER_CENTER.VACANCIES.VACANCIES, {params});
	return response.data;
};

const getVacancyByID = async (id: any, params?: any) => {
	const response = await axiosClient.get(api.CAREER_CENTER.VACANCIES.VACANCY_BY_ID + id, {params});
	return response.data;
};

const createVacancy = async (data: any) => {
	const response = await axiosClient.post(api.CAREER_CENTER.VACANCIES.VACANCIES, formData(data, 'ADD'));
	return response.data;
};

const updateVacancy = async (id: any, data: any) => {
	const response = await axiosClient.patch(api.CAREER_CENTER.VACANCIES.VACANCY_BY_ID + id, formData(data));
	return response.data;
};

const deleteVacancies = async (ids: any) => {
	const response = await axiosClient.delete(api.CAREER_CENTER.VACANCIES.VACANCIES_BY_IDS + ids);
	return response.data;
};

const getApplicantByID = async (studentID: any, params?: any) => {
	const response = await axiosClient.get(api.CAREER_CENTER.VACANCIES.APPLICANT_BY_STUDENT_ID + studentID, {
		params
	});
	return response.data;
};

const updateApplicationStatus = async (applicationID: any, applicationStatus: string) => {
	const response = await axiosClient.patch(
		api.CAREER_CENTER.VACANCIES.APPLICATION_STATUS_BY_ID + applicationID + '/status',
		{applicationStatus}
	);
	return response.data;
};

const sendCVToEmployer = async (vacancyID: any, studentID: any, data?: any) => {
	const formData = new FormData();
	// An empty cv tells the back end to attach the applicant's stored CV; the
	// filename argument is only legal on Blob values.
	if (data?.cv instanceof Blob) {
		formData.append('cv', data.cv, 'cv.pdf');
	} else {
		formData.append('cv', '');
	}
	const response = await axiosClient.post(
		api.CAREER_CENTER.VACANCIES.VACANCIES + '/' + vacancyID + '/applicants/' + studentID + '/send-cv',
		formData
	);
	return response.data;
};

const service = {
	getVacancies,
	getVacancyByID,
	createVacancy,
	updateVacancy,
	deleteVacancies,
	getApplicantByID,
	updateApplicationStatus,
	sendCVToEmployer
};

export default service;
